import { Share } from "@mui/icons-material";
import { Fab } from "@mui/material";
import { ControlOptions } from "leaflet";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { MapControlBase } from "./MapControlBase";

interface Props extends ControlOptions {}

export function ShareControl(props: Props) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const shareURL = window.location.href;

  function onClick() {
    navigator.clipboard.writeText(shareURL);
    enqueueSnackbar(t("message.urlCopiedToClipboard", { variant: "info" }));
  }

  return (
    <MapControlBase {...props}>
      <Fab size="small" variant="circular" onClick={onClick}>
        <Share />
      </Fab>
    </MapControlBase>
  );
}
